
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {finalize, tap, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
//import 'rxjs/Rx';
//import { AngularReduxRequestOptions } from '../redux/angular-redux-request.options';
import { LoadingService } from './loading.service';
//import { HttpClient, HttpHandler, HttpEvent, HttpEventType, HttpRequest, HttpParams, HttpHeaders, HttpResponse } from '../../../../node_modules/@angular/common/http';
import { environment } from '../../../environments/environment';
import { Paginator } from '../models/base.model';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';


@Injectable()
export class HttpService {

    constructor(
        //backend: XHRBackend,
        //defaultOptions: AngularReduxRequestOptions,
        //handler : HttpHandler,
        //private loaderService: LoadingService,
        private httpClient: HttpClient
    ) {
        //super(handler);
        //super(backend,defaultOptions);
    }

    countLoader: number = 0

    // get(url: string): Observable<any> {
    //     //this.showLoader(url);
    //     return this.httpClient.get<any>(this.getFullUrl(url))
    //         .catch(this.onCatch)
    //         .do((res: Response) => {

    //             this.onSuccess(res)
    //         }, (error: any) => {
    //             this.onError(error)
    //         })
    //         .finally(() => {
    //             this.onEnd(url)
    //         });

    //     //return this.sendRequest('GET', url);
    // }

    get(url: string, responseType: any = 'json'): Observable<any> {
        // debugger
        //this.showLoader(url);
        return this.httpClient.get<any>(this.getFullUrl(url), { responseType: responseType }).pipe(
            catchError(this.onCatch),
            tap((res: Response) => {
                this.onSuccess(res)
            }, (error: any) => {
                this.onError(error)
            }),
            finalize(() => {
                this.onEnd(url)
            }),);

        //return this.sendRequest('GET', url);
    }

    getWithParams(url: string, params: any, responseType: any = 'json'): Observable<any> {
        // debugger
        //this.showLoader(url);
        return this.httpClient.get<any>(this.getFullUrl(url), { params: params, responseType: responseType }).pipe(
            catchError(this.onCatch),
            tap((res: Response) => {
                this.onSuccess(res)
            }, (error: any) => {
                this.onError(error)
            }),
            finalize(() => {
                this.onEnd(url)
            }),);

        //return this.sendRequest('GET', url);
    }

    post(url: string, body: any, options?: any): Observable<any> {

        return this.httpClient.post<any>(this.getFullUrl(url), body, options).pipe(
            catchError(
                this.onCatch
            ),
            tap((res: Response) => {
                //console.log('*** POST: success : ' + url)
                this.onSuccess(res)
            }, (error: any) => {
                //console.log('*** POST: error : ' + url)
                this.onError(error)
            }),
            finalize(() => {
                //onsole.log('*** POST: finally : ' + url)
                this.onEnd(url)
            }),)
    }

    postWithPadginator(url: string, body: any, pagin?: Paginator): Observable<HttpResponse<any>> {
        return this.httpClient.post<HttpResponse<any>>(this.getFullUrl(url), body,
            {
                headers: new HttpHeaders({ "pagin-data": JSON.stringify(pagin) }),
                observe: 'response'
            }).pipe(
            catchError(
                this.onCatch
            ),
            tap((res: any) => {
                //console.log('*** POST: success : ' + url)
                if (pagin) {
                    pagin.TotalRecordCount = Number(res.headers.get('X-Paging-TotalRecordCount'));
                }
                this.onSuccess(res)
            }, (error: any) => {
                //console.log('*** POST: error : ' + url)
                this.onError(error)
            }),
            finalize(() => {
                //onsole.log('*** POST: finally : ' + url)
                this.onEnd(url)
            }),)
    }


    put(url: string, body: any): Observable<any> {
        return this.httpClient.put<any>(this.getFullUrl(url), body).pipe(
            catchError(this.onCatch),
            tap((res: Response) => {
                this.onSuccess(res)
            }, (error: any) => {
                this.onError(error)
            }),
            finalize(() => {
                this.onEnd(url)
            }),)
    }

    delete(url: string): Observable<any> {
        return this.httpClient.delete<any>(this.getFullUrl(url)).pipe(
            catchError(this.onCatch),
            tap((res: Response) => {
                // console.log('success : ' + url)
                this.onSuccess(res)
            }, (error: any) => {
                this.onError(error)
            }),
            finalize(() => {
                this.onEnd(url)
            }),)
    }

    deleteWithParam(url: string, param: HttpParams): Observable<any> {
        return this.httpClient.delete<any>(this.getFullUrl(url), {
            params: param
        }).pipe(catchError(this.onCatch),
            tap((res: Response) => {
                this.onSuccess(res)
            }, (error: any) => {
                this.onError(error)
            }),
            finalize(() => {
                this.onEnd(url)
            }),)
    }

    // private requestOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
    //     if (options == null) {
    //         options = new AngularReduxRequestOptions();
    //     }
    //     if (options.headers == null) {
    //         options.headers = new Headers();
    //     }
    //     return options;
    // }

    private getFullUrl(url: string): string {
        return `${environment.webApiUrl}` + url
    }

    private onCatch(error: any, caught: Observable<any>): Observable<any> {
        // console.log('*** ----------catch : error =>', error)
        return observableThrowError(error);
    }

    private onSuccess(res: Response): void {
        // console.log('Request successful');
    }

    private onError(res: Response): void {
        // console.log('Error, status code: ' + res.status);
    }

    private onEnd(url: string): void {
        //this.hideLoader(url);
    }

    /*
        private showLoader(url: string): void {
            this.countLoader++
            if (this.countLoader === 1) {
                this.loaderService.showLoading()
               console.log('-------- show_Loader => ', this.countLoader + " : " + url)
            } else if (this.countLoader < 0) {
                this.countLoader = 0
               console.log('show_Loader => ', this.countLoader + " : " + url)
            } else {
               console.log('-------- show_Loader => ', this.countLoader + " : " + url)
            }
        }
    
        private hideLoader(url: string): void {
            if (this.countLoader > 0) {
                this.countLoader--
                if (this.countLoader === 0) {
                    this.loaderService.hideLoading()
                   console.log('-------- hide_Loader => ', this.countLoader + ' : ' + url)
                } else {
                   console.log('hide_Loader => ', this.countLoader + ' : ' + url)
                }
            } else {
                this.countLoader = 0
               console.log('** hide_Loader => ', this.countLoader + ' : ' + url)
            } 
        }*/
}